module.exports = __webpack_public_path__ + "img/Endangered-Animals-01.cfdcf743.jpg";